import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'
import { useUserOrganization } from '@modules-deprecated/app/organization'

type HeaderLabels = {
  [key in InvoiceLineColumn]: string
}

export const useInvoiceLineHeaderLabels = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  const headerLabels: Partial<HeaderLabels> = useMemo(
    () => ({
      description: t('external_invoices.editor.form.field.line.header.name'),
      discount: t('external_invoices.editor.form.field.line.header.discount'),
      productType: t('external_invoices.editor.form.field.line.header.type'),
      date: t('external_invoices.editor.form.field.line.header.date'),
      quantity: t('external_invoices.editor.form.field.line.header.quantity'),
      unit: t('external_invoices.editor.form.field.line.header.unit'),
      unitPrice: t('external_invoices.editor.form.field.line.header.unit_price'),
      vatPct: t('external_invoices.editor.form.field.line.header.vat'),
      netTotal: t('external_invoices.editor.form.field.line.header.total_excluding_vat'),
      total: organization?.isVatExempted
        ? t('external_invoices.editor.form.field.line.header.total')
        : t('external_invoices.editor.form.field.line.header.total_including_vat'),
    }),
    [organization?.isVatExempted, t],
  )

  const getHeaderLabel = useCallback(
    (columnName: InvoiceLineColumn) => (headerLabels[columnName] ? headerLabels[columnName] : null),
    [headerLabels],
  )

  return { getHeaderLabel }
}
